import { useIntl } from 'react-intl';
import Edit from 'src/componentes/edit/edit-dialog';
import Geral from './geral';
import { Schema } from 'src/utils/form';

const schema = Schema.object({
  estagio: Schema.string().required(),
  data: Schema.string().required(),
  valor: Schema.string().required(),
});

const EditForm = ({ model, ...rest }) => {
  const projetoId = rest.parameters?.projetoId ?? null;
  return <Geral model={model} projetoId={projetoId} />;
};

const EditView = (props) => {
  const intl = useIntl();

  return (
    <Edit
      {...props}
      url="/DetalhamentoFinanceiro"
      title={intl.formatMessage({ id: 'detalhamentoFinanceiro' })}
      schema={schema}
      formComponent={EditForm}
      width="75%"
      height={500}
      intl={intl}
      showExport={false}
    />
  );
};

export default EditView;
